import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';

import styles from './chatbot-message.module.css';

interface ChatbotMessageProps {
  message: string;
  time?: string;
  isUser: boolean;
}

const ChatbotMessage: React.FC<ChatbotMessageProps> = ({
  message,
  time,
  isUser,
}) => {
  return (
    <div className={classNames(styles.message, !isUser ? styles.darker : null)}>
      <div className={styles.text}>
        <ReactMarkdown>{message}</ReactMarkdown>
      </div>
      {time && <span className={styles.time}>{time}</span>}
    </div>
  );
};

export default ChatbotMessage;
